const categories = [
  { label: 'Arts & Entertainment', value: 1 },
  { label: 'Automotive', value: 2 },
  { label: 'Business', value: 3 },
  { label: 'Careers', value: 4 },
  { label: 'Education', value: 5 },
  { label: 'Family & Parenting', value: 6 },
  { label: 'Health & Fitness', value: 7 },
  { label: 'Food & Drink', value: 8 },
  { label: 'Hobbies & Interests', value: 9 },
  { label: 'Home & Garden', value: 10 },
  { label: 'Law, Gov’t & Politics', value: 11 },
  { label: 'News', value: 12 },
  { label: 'National News', value: 13 },
  { label: 'Local News', value: 14 },
  { label: 'Personal Finance', value: 15 },
  { label: 'Society', value: 16 },
  { label: 'Science', value: 17 },
  { label: 'Weather', value: 18 },
  { label: 'Pets', value: 19 },
  { label: 'Sports', value: 20 },
  { label: 'Auto Racing', value: 21 },
  { label: 'Boxing', value: 22 },
  { label: 'Style & Fashion', value: 23 },
  { label: 'Fashion', value: 24 },
  { label: 'Technology & Computing', value: 25 },
  { label: 'Computer Certification', value: 26 },
  { label: 'Computer Reviews', value: 27 },
  { label: 'Entertainment', value: 28 },
  { label: 'Travel', value: 29 },
  { label: 'Shopping', value: 30 },
  { label: 'Power & Motorcycles', value: 31 },
  { label: 'Television', value: 32 },
  { label: 'Car Culture', value: 33 },
  { label: 'Celebrity Fan/Gossip', value: 34 },
  { label: 'Humor', value: 35 },
  { label: 'Babies & Toddlers', value: 36 },
  { label: 'Video & Computer Games', value: 37 },
  { label: 'Hunting/Shooting', value: 38 },
  { label: 'Home Repair', value: 39 },
  { label: 'Interior Decorating', value: 40 },
  { label: 'Financial News', value: 41 },
  { label: 'Investing', value: 42 },
] as const;

export default categories;
